import {SYSTEMSETTING} from 'Constants/ActionTypes';

const {
  POST_USER_LIST,
  GET_USER_ROLE_SELECT,
  POST_USER_ROLEBINDING
} = SYSTEMSETTING;

const initialState = {
  tableListData: {
    data: [],
    total: 0,
  }, // table数据
  pageStatus: {
    pageNum: 1,
    pageSize: 20,
  }, // pageNum与pageSize
};

const userManagement = (state = initialState, action) => {
  switch (action.type) {
    case `${POST_USER_LIST}_SUCCESS`:
      return {
        ...state,
        tableListData: {
          data: (action.payload.data && action.payload.data.list) || [],
          total: (action.payload.data && action.payload.data.total) || 0,
        },
      };
    default:
      return state;
  }
};

export default userManagement;
